import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const firebaseConfig = {
  // Fill up the config to run the app
  apiKey: "AIzaSyBAZXYH_CcCbyqTGnLLfVFXqyyXXu7Q97U",
  authDomain: "cl-5b1fd.firebaseapp.com",
  projectId: "cl-5b1fd",
  storageBucket: "cl-5b1fd.appspot.com",
  messagingSenderId: "1091320665139",
  appId: "1:1091320665139:web:fb9a4d94c9eb3b31f7ff46",
  measurementId: "G-J2DWHSK673"
};

firebase.default.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
